export default __webpack_public_path__ + "static/media/gallery-wip-neck-rib_03.61d4fee0.jpg";